import { gql } from '@apollo/client';

export const LIVE_CLASSROOM_STUDENTS_SUBSCRIPTION = gql`
  subscription GetLiveClassroomStudents(
    $input: getLiveClassroomStudentsInput!
  ) {
    getLiveClassroomStudents(input: $input) {
      studentId
      firstName
      lastName
      email
      username
      emeji
      action
    }
  }
`;
